module.exports = __webpack_public_path__ + "static/media/Chongoni_icon_200px.156fd713.png";